<template>
  <div class="biasfx2">
    <Banner :with-bias-banner="true" />
    <div style="position: relative;">
      <BiasFx2Banner />
    </div>
    <section
      class="section section-propack-blues sound"
      :style="{backgroundImage: `url(${require(`@/assets/bias-fx2/sound-page/01_header_bg.jpg`)})`}"
    >
      <div class="grid-container">
        <div class="grid-half-item grid-full-width">
          <div class="inner">
            <div class="column-content">
              <h1
                style="font-size:50px"
                class="title white-20"
              >
                音色与特性
              </h1>
              <h3 class="subtitle" />
              <div>
                <p
                  style="font-size:17px; font-weight:500"
                  class="text"
                >
                  BIAS FX 2 为你带来的不仅有大量的音箱、效果器和HD机架，还有新推出的吉他匹配技术。它为任何想要创造自己梦想音色的吉他手和贝斯手提供了一站式解决方案。再加上全新的DSP引擎、直观用户界面以及循环录音机等等众多功能，BIAS FX 2 就真正成为世界领先的虚拟音箱和效果处理解决方案。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-guitar-match sound">
      <div class="grid-container radial-grident-gray-20">
        <div class="grid-half-item grid-full-width">
          <div class="inner">
            <div class="column-content">
              <div class="new-seal">
                <span class="gray-20 gray-20-border">新特性</span>
              </div>
              <h2 class="title gray-20">
                吉他匹配
              </h2>
              <h3 class="subtitle">
                让你的吉他魔法变身
              </h3>
              <div>
                <p class="text">
                  吉他匹配功能会分析你的吉他的整体响应，并将你的乐器变成我们精心挑选的18只传奇吉他中的任意一款。其中的算法智能到能模拟多种不同的琴体形状、音色木材、以及拾音器的配置 - 不再需要特殊的拾音器。
                </p>
              </div>
            </div>
            <Carousel :options="CarouselSettings['guitar-match']" />
          </div>
        </div>
      </div>
    </section>
    <section class="section section-amp-match sound">
      <div class="grid-container radial-grident-dark-brown">
        <div class="grid-half-item grid-full-width">
          <div class="inner">
            <div class="column-content">
              <div class="new-seal">
                <span class="dark-brown dark-brown-border">新特性</span>
              </div>
              <h2 class="title dark-brown">
                动态音箱引擎
              </h2>
              <h3 class="subtitle">
                超真实的触感响应
              </h3>
              <div>
                <p class="text">
                  BIAS FX 2 与BIAS AMP 2 一样有着行业领先的音箱引擎，因此你可以使用100个新设计的、细致到元件级别的音箱型号，从经典的清音音箱到现代的高增益音箱，从震撼的贝斯音箱到原声音箱，应有尽有。
                </p>
              </div>
            </div>
            <Carousel :options="CarouselSettings['amp']" />
          </div>
        </div>
      </div>
    </section>
    <section class="section section-amp-design-and-modeler sound">
      <div class="grid-container radial-grident-dark-green-brown">
        <div class="grid-half-item grid-full-width">
          <div class="inner">
            <div class="column-content">
              <div class="new-seal">
                <span class="dark-green-brown dark-green-brown-border">新特性</span>
              </div>
              <h2 class="title dark-green-brown">
                箱体/话筒
              </h2>
              <h3 class="subtitle">
                找到最能代表你自己的音色
              </h3>
              <div>
                <p class="text">
                  通过一系列世界知名的箱体、扬声器和话筒型号以及 Celestion<span style="font-size: 1rem; vertical-align: top;">®</span> 官方的脉冲响应(IRs)来找到属于你的声音。
                </p>
              </div>
            </div>
            <Carousel :options="CarouselSettings['cab']" />
          </div>
        </div>
      </div>
    </section>
    <section class="section sound continue-above-section">
      <div class="grid-container grid-half-container-fx2">
        <div class="column-content">
          <div class="new-seal">
            <span class="dark-green-brown dark-green-brown-border">新特性</span>
          </div>
          <h2 class="title dark-green-brown">
            单块效果器
          </h2>
          <h3 class="subtitle">
            完善你的声音色彩和个性
          </h3>
          <div>
            <p class="text">
              解锁各种不同的知名效果器，这些模拟的和数字的效果器不仅建模到原件级别，而且还有如照片一般真实的界面，这样一来创造和定制你自己梦想中的信号链就变得前所未有的容易。
            </p>
          </div>
        </div>
      </div>
      <div class="grid-half-container grid-half-container-fx2">
        <div class="grid-half-column left card">
          <div class="grid-half-item">
            <div>
              <div class="line" />
              <div class="inner">
                <div class="column-content">
                  <h3>噪声门</h3>
                  <p class="desktop-text">
                    如狙击手般精准的噪声门/降噪效果器，尤其适合于清除信号链中令人讨厌的噪声。
                  </p>
                </div>
                <div class="column-content pedal-image">
                  <figure>
                    <img
                      class="lazyload lazeload-placeholder"
                      src="@/assets/bias-fx2/sound-page/02_01_gate.png"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
                <div class="pg-soundcloud-block-holder" />
              </div>
            </div>
          </div>
        </div>
        <div class="grid-half-column right card">
          <div class="grid-half-item">
            <div>
              <div class="line" />
              <div class="inner">
                <div class="column-content">
                  <h3>压缩</h3>
                  <p class="desktop-text">
                    基于使用最为广泛的单块和录音棚压缩器。可以用来提高饱和度、增加延音并将你的音色提升到下一个高度。
                  </p>
                </div>
                <div class="column-content pedal-image">
                  <figure>
                    <img
                      class="lazyload lazeload-placeholder"
                      src="@/assets/bias-fx2/sound-page/02_02_compressor.png"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
                <div class="pg-soundcloud-block-holder" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid-half-container grid-half-container-fx2 grid-half-container-low-top-pad">
        <div class="grid-half-column left card">
          <div class="grid-half-item">
            <div>
              <div class="line" />
              <div class="inner">
                <div class="column-content">
                  <h3>提升</h3>
                  <p class="desktop-text">
                    不仅包含我们所有的经典提升单块，还有更多全新的型号。尤其适合于提升你的信号来创造丰满、温暖的失真或是只简单的用来增加信号的音量。
                  </p>
                </div>
                <div class="column-content pedal-image">
                  <figure>
                    <img
                      class="lazyload lazeload-placeholder"
                      src="@/assets/bias-fx2/sound-page/02_03_boost.png"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
                <div class="pg-soundcloud-block-holder">
                  <sound-clip
                    :url="'pedal/Boost (BIAS Preamp) VR.mp3'"
                    :name="'来自于BIAS前置放大器'"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-half-column right card">
          <div class="grid-half-item">
            <div>
              <div class="line" />
              <div class="inner">
                <div class="column-content">
                  <h3>失真</h3>
                  <p class="desktop-text">
                    众多最受追捧的模拟过载、失真和法兹单块，适合于给你的信号线路增添从轻微的过载、饱和/增益一直到完全的经典法兹效果。
                  </p>
                </div>
                <div class="column-content pedal-image">
                  <figure>
                    <img
                      class="lazyload lazeload-placeholder"
                      src="@/assets/bias-fx2/sound-page/02_04_distortion.png"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
                <div class="pg-soundcloud-block-holder">
                  <sound-clip
                    :url="'pedal/Distortion (Dumble clean) VR.mp3'"
                    :name="'Dumble Clean音箱'"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid-half-container grid-half-container-fx2 grid-half-container-low-top-pad">
        <div class="grid-half-column left card">
          <div class="grid-half-item">
            <div>
              <div class="line" />
              <div class="inner">
                <div class="column-content">
                  <h3>均衡</h3>
                  <p class="desktop-text">
                    建模于行业领先的、也是在世界上最受欢迎的录音棚里使用的单块和机架均衡器。用来精准定位和提升/衰减特定频率来帮助塑造你的音色。
                  </p>
                </div>
                <div class="column-content pedal-image">
                  <figure>
                    <img
                      class="lazyload lazeload-placeholder"
                      src="@/assets/bias-fx2/sound-page/02_05_eq.png"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
                <div class="pg-soundcloud-block-holder" />
              </div>
            </div>
          </div>
        </div>
        <div class="grid-half-column right card">
          <div class="grid-half-item">
            <div>
              <div class="line" />
              <div class="inner">
                <div class="column-content">
                  <h3>调制</h3>
                  <p class="desktop-text">
                    通过这些永不过时的调制效果来扩展你的声音世界，从经典的音量颤音、怪异的Mutron包络滤波器一直到太空时代的移相效果，无所不有。
                  </p>
                </div>
                <div class="column-content pedal-image">
                  <figure>
                    <img
                      class="lazyload lazeload-placeholder"
                      src="@/assets/bias-fx2/sound-page/02_06_modulation.png"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
                <div class="pg-soundcloud-block-holder">
                  <sound-clip
                    :url="'pedal/Modulation (Lush Ensemble) VR.mp3'"
                    :name="'Lush Ensemble（华丽合奏）单块'"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid-half-container grid-half-container-fx2 grid-half-container-low-top-pad">
        <div class="grid-half-column left card">
          <div class="grid-half-item">
            <div>
              <div class="line" />
              <div class="inner">
                <div class="column-content">
                  <h3>延时</h3>
                  <p class="desktop-text">
                    有史以来最受推崇的一些延时效果器。模拟、数字、磁带、乒乓、回声、反向 - 你叫得上名字的都有，我们精心再现了这些效果直到最后一个反复的声音。
                  </p>
                </div>
                <div class="column-content pedal-image">
                  <figure>
                    <img
                      class="lazyload lazeload-placeholder"
                      src="@/assets/bias-fx2/sound-page/02_07_delay.png"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
                <div class="pg-soundcloud-block-holder">
                  <sound-clip
                    :url="'pedal/Delay (Slapback delay) VR.mp3'"
                    :name="'Slapback延时'"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-half-column right card">
          <div class="grid-half-item">
            <div>
              <div class="line" />
              <div class="inner">
                <div class="column-content">
                  <h3>混响</h3>
                  <p class="desktop-text">
                    一系列真实再现的经典、华丽的混响机架和单块效果器，用来重现我们熟知并喜爱的自然声学空间。
                  </p>
                </div>
                <div class="column-content pedal-image">
                  <figure>
                    <img
                      class="lazyload lazeload-placeholder"
                      src="@/assets/bias-fx2/sound-page/02_08_reverb.png"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
                <div class="pg-soundcloud-block-holder">
                  <sound-clip
                    :url="'pedal/Reverb (Ambient reverb) VR.mp3'"
                    :name="'环境混响'"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-propack-blues sound">
      <div class="grid-container radial-grident-gray-20">
        <div class="grid-half-item grid-full-width">
          <div class="inner">
            <div class="column-content">
              <div class="new-seal">
                <span class="gray-20 gray-20-border">新特性</span>
              </div>
              <h2 class="title gray-20">
                建模效果器
              </h2>
              <h3 class="subtitle">
                通过更高水准的效果器来探索新的领域
              </h3>
              <div>
                <p class="text">
                  定制性超强的和声、时间以及法兹建模效果器，可以让你调整大量的内部参数，或是从零开始定制你的梦想效果器。
                </p>
              </div>
            </div>
            <Carousel :options="CarouselSettings['modeler']" />
          </div>
        </div>
      </div>
    </section>
    <section class="section sound continue-above-section">
      <div class="grid-container grid-half-container-fx2">
        <div class="column-content">
          <div class="new-seal">
            <span class="dark-green-brown dark-green-brown-border">新特性</span>
          </div>
          <h2 class="title dark-green-brown">
            录音棚机架效果器
          </h2>
          <h3 class="subtitle">
            通过老式的录音棚设备来强化你的声轨
          </h3>
          <div>
            <p class="text">
              世界知名的老式高端机架处理器就在你的指尖之下，其中每一款都是建模到元件的程度，并且在细节上也是极为注重。
            </p>
          </div>
        </div>
      </div>
      <div class="grid-half-container grid-half-container-fx2">
        <div class="grid-half-column left card">
          <div class="grid-half-item">
            <div>
              <div class="line" />
              <div class="inner">
                <div class="column-content">
                  <h3>三重合唱</h3>
                  <p class="desktop-text">
                    通过这款80年代合唱效果器的真正重现来创造真实而又宽广的立体声空间，同时还可以通过在3个可调节合唱位置之间的切换来实现更多的声音多样性。
                  </p>
                </div>
                <div class="column-content rack-image">
                  <figure>
                    <img
                      class="lazyload lazeload-placeholder"
                      src="@/assets/bias-fx2/sound-page/03_01_trichorus.png"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
                <div class="pg-soundcloud-block-holder">
                  <sound-clip
                    :url="'hd-racks/Tri Chorus HD VR.mp3'"
                    :name="'三重合唱'"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-half-column right card">
          <div class="grid-half-item">
            <div>
              <div class="line" />
              <div class="inner">
                <div class="column-content">
                  <h3>多段压缩</h3>
                  <p class="desktop-text">
                    建模于深受大家喜爱的录音棚标准级的多段电子管压缩器。可以轻松地分离、定位和压缩特定的低、中、高频段。
                  </p>
                </div>
                <div class="column-content rack-image">
                  <figure>
                    <img
                      class="lazyload lazeload-placeholder"
                      src="@/assets/bias-fx2/sound-page/03_02_multi_comp.png"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
                <div class="pg-soundcloud-block-holder">
                  <sound-clip
                    :url="'hd-racks/Multi Compressor HD VR.mp3'"
                    :name="'多段压缩'"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid-half-container grid-half-container-fx2 grid-half-container-low-top-pad">
        <div class="grid-half-column left card">
          <div class="grid-half-item">
            <div>
              <div class="line" />
              <div class="inner">
                <div class="column-content">
                  <h3>哇音HD</h3>
                  <p class="desktop-text">
                    一款真正怪兽级的哇音效果器，结合了我们熟知并喜爱的各种经典哇音效果器上的可调节参数。既可以略微用那么一点，也可以像Slash一样火力全开。
                  </p>
                </div>
                <div class="column-content rack-image">
                  <figure>
                    <img
                      class="lazyload lazeload-placeholder"
                      src="@/assets/bias-fx2/sound-page/03_03_wah.png"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
                <div class="pg-soundcloud-block-holder">
                  <sound-clip
                    :url="'hd-racks/Wah HD VR.mp3'"
                    :name="'哇音HD'"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-half-column right card">
          <div class="grid-half-item">
            <div>
              <div class="line" />
              <div class="inner">
                <div class="column-content">
                  <h3>大型多点式延时</h3>
                  <p class="desktop-text">
                    这款超级灵活的现代延时效果器可以让你任意控制延迟时间、调制形态与模式，从而产生出巨大而空灵的声音景象。
                  </p>
                </div>
                <div class="column-content rack-image">
                  <figure>
                    <img
                      class="lazyload lazeload-placeholder"
                      src="@/assets/bias-fx2/sound-page/03_04_mega_tap.png"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
                <div class="pg-soundcloud-block-holder" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid-half-container grid-half-container-fx2 grid-half-container-low-top-pad">
        <div class="grid-half-column left card">
          <div class="grid-half-item">
            <div>
              <div class="line" />
              <div class="inner">
                <div class="column-content">
                  <h3>磁鼓延时</h3>
                  <p class="desktop-text">
                    建模于来自于20世纪50年代的高端Echorec磁鼓延时效果器，重现了其中的每一个参数，让你拥有对这款经典外部设备的绝对控制权。尤其适合于实现超快的、具有复古氛围的短延时效果。
                  </p>
                </div>
                <div class="column-content rack-image">
                  <figure>
                    <img
                      class="lazyload lazeload-placeholder"
                      src="@/assets/bias-fx2/sound-page/03_05_echorex.png"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
                <div class="pg-soundcloud-block-holder" />
              </div>
            </div>
          </div>
        </div>
        <div class="grid-half-column right card">
          <div class="grid-half-item">
            <div>
              <div class="line" />
              <div class="inner">
                <div class="column-content">
                  <h3>高级压缩</h3>
                  <p class="desktop-text">
                    最先进并且功能丰富的压缩器，提供了每一个可能的参数。可以用来增加饱和度、延音并以极高的准确度来规格化动态响应。
                  </p>
                </div>
                <div class="column-content rack-image">
                  <figure>
                    <img
                      class="lazyload lazeload-placeholder"
                      src="@/assets/bias-fx2/sound-page/03_06_advanced_comp.png"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
                <div class="pg-soundcloud-block-holder">
                  <sound-clip
                    :url="'hd-racks/Advance Compressor VR.mp3'"
                    :name="'高级压缩'"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid-half-container grid-half-container-fx2 grid-half-container-low-top-pad">
        <div class="grid-half-column left card">
          <div class="grid-half-item">
            <div>
              <div class="line" />
              <div class="inner">
                <div class="column-content">
                  <h3>旋转扬声器</h3>
                  <p class="desktop-text">
                    我们重现了在过去的岁月中最出名的旋转箱体 - 莱斯利旋转扬声器的经典音色和感觉。可以用来创造极具回旋感的节奏脉动并给任何吉他音色增添一些复古的氛围。
                  </p>
                </div>
                <div class="column-content rack-image">
                  <figure>
                    <img
                      class="lazyload lazeload-placeholder"
                      src="@/assets/bias-fx2/sound-page/03_07_rotary.png"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
                <div class="pg-soundcloud-block-holder">
                  <sound-clip
                    :url="'hd-racks/Rotary VR.mp3'"
                    :name="'旋转扬声器'"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-half-column right card">
          <div class="grid-half-item">
            <div>
              <div class="line" />
              <div class="inner">
                <div class="column-content">
                  <h3>弹簧混响</h3>
                  <p class="desktop-text">
                    这款重现的经典弹簧混响不仅可以调节混响量的大小，还可以通过调节弹簧的张力来创造华丽、广阔的混响效果。演奏起来的感觉就像真实的设备一样。
                  </p>
                </div>
                <div class="column-content rack-image">
                  <figure>
                    <img
                      class="lazyload lazeload-placeholder"
                      src="@/assets/bias-fx2/sound-page/03_08_spring.png"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
                <div class="pg-soundcloud-block-holder">
                  <sound-clip
                    :url="'hd-racks/Spring Reverb HD VR.mp3'"
                    :name="'弹簧混响'"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-propack-blues sound">
      <div class="grid-container radial-grident-gray-20">
        <div class="grid-half-item grid-full-width">
          <div class="inner">
            <div class="column-content">
              <div class="new-seal">
                <span class="gray-20 gray-20-border">新特性</span>
              </div>
              <h2 class="title gray-20">
                音色云
              </h2>
              <h3 class="subtitle">
                加入BIAS在线社区
              </h3>
              <div>
                <p class="text">
                  通过音色云来创造、分享或下载定制预置音色。在数以千计可选预设的基础上，我们还与大家喜爱的艺术家、录音乐手和录音师合作，来不断扩展已经是海量的音色云预设库，从而为大家提供持续增长的、专为BIAS FX 2 打造的虚拟单块效果链和吉他装备。
                </p>
              </div>
            </div>
            <div
              class="gallery"
              data-group="5"
            >
              <div class="gallery-main-content">
                <div
                  id="gallery-item-group5-1"
                  class="gallery-item"
                  aria-hidden="true"
                >
                  <figure class="image-container">
                    <img
                      width="859"
                      height="624"
                      src="@/assets/bias-fx2/sound-page/04_tone_cloud.jpg"
                      alt=""
                    >
                  </figure>
                </div>
              </div>
              <div class="dotnav-wrapper" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer-common />
  </div>
</template>

<script>
import BiasFx2Banner from '@/components/bias-fx2-banner'
import Banner from '@/components/banner'

import FooterCommon from '@/components/footer-common'

import SoftwareImageLite from '@/assets/fx-software/image-lite@2x.png'
import SoftwareImageStandard from '@/assets/fx-software/image-standard@2x.png'
import SoftwareImagePro from '@/assets/fx-software/image-pro@2x.png'

import ExpansionImageAcoustic from '@/assets/expansion/image-acoustic-pack@2x.png'
import ExpansionImageBass from '@/assets/expansion/image-bass-pack@2x.png'
import ExpansionImageMetal from '@/assets/expansion/image-metal-pack@2x.png'

import Carousel from '@/components/carousel'
import CarouselSettings from '@/components/bias-fx2-carousel.json'

import SoundClip from '@/components/soundclip'

import jwtDecode from 'jwt-decode'

import store from '@/store'

export default {
  name: 'Index',
  store,
  components: {
    Banner,
    FooterCommon,
    BiasFx2Banner,
    Carousel,
    SoundClip
  },
  data () {
    return {
      showModal: false,
      showModalId: null,
      SoftwareImageLite,
      SoftwareImageStandard,
      SoftwareImagePro,
      ExpansionImageAcoustic,
      ExpansionImageBass,
      ExpansionImageMetal,
      CarouselSettings
    }
  },
  computed: {},
  mounted: function () {
    const pgToken = this.hasLoginToken()
    if (pgToken) {
      this.setLoginToken(pgToken)
      const email = jwtDecode(pgToken)['email']
      this.setLoginEmail(email)
    }
  },
  methods: {
    openModal (url) {
      this.showModal = true
      this.showModalId = url
    },
    closeModal () {
      this.showModal = false
    },
    hasLoginToken () {
      let qs = window.location.toString().split('?')[1]
      qs = new window.URLSearchParams('?' + qs)
      return qs.get('pg_token')
    },
    setLoginToken (token) {
      window.localStorage.setItem('PG_TOKEN', token)
    },
    setLoginEmail (email) {
      window.localStorage.setItem('PG_EMAIL', email)
    }
  }
}
</script>

<style scoped lang="scss">
@import "../styles/pages/bias-fx2.scss";
.grid-half-container .desktop-text {
    min-height: 8em;
}
</style>



// WEBPACK FOOTER //
// src/pages/bias-fx2-feature.vue